module.exports = __webpack_public_path__ + "media/images/teams/NAPOLI-23e5541e8d90baabbdae72b44fff8961.png";